const logos = {
    logo_nomanejes: { src: "/images/banner/logo_nomanejes.svg", alt: "Logo Nomanejes", href: "https://www.nomanejes.com" },
    logo_puerto_rico_car_transfer: { src: "/images/banner/logo_puertoricocartransfer.svg", alt: "Logo Puerto Rico Car Transfer", href: "https://www.puertoricocartransfer.com" },
    logo_carro_a_centro_america: { src: "/images/banner/logo_carrosacentroamerica.svg", alt: "Logo Carro a Centro America", href: "https://www.carrosacentroamerica.com" },
    logo_pr_autotransport: { src: "/images/banner/logo_prautotransport.svg", alt: "Logo PR Autotransport", href: "https://www.prautotransport.com" },
    logo_carmoversus: { src: "/images/banner/logo_carmoversus.svg", alt: "Logo Carmoversus", href: "https://www.carmoversus.com" },
    logo_shipshippersusa: { src: "/images/banner/logo_shipshippersusa.svg", alt: "Logo Shipshippers USA", href: "https://www.shipshippersusa.com" },
    logo_ratesautotransport: { src: "/images/banner/logo_ratesautotransport.svg", alt: "Logo Rates Autotransport", href: "https://www.ratesautotransport.com" },
    logo_tucarroporusa: { src: "/images/banner/logo_tucarroporusa.svg", alt: "Logo Tu Carro Por Usa", href: "https://www.tucarroporusa.com" },
    logo_tcpamerica: { src: "/images/banner/logo_tcpamerica.svg", alt: "Logo TCP America", href: "https://www.tucarroporamerica.com" },
}

const logos_ally = {
    logo_ally_centraldispatch: { src: "/images/banner/logo_ally_centraldispatch.svg", alt: "Logo Ally Central Dispatch", href: "https://www.centraldispatch.com" },
    logo_ally_seaboard: { src: "/images/banner/logo_ally_seaboardmarine.svg", alt: "Logo Ally Seaboard", href: "https://www.seaboardmarine.com" },
    logo_ally_trailerbridge: { src: "/images/banner/logo_ally_trailerbridge.svg", alt: "Logo Ally Trailer Bridge", href: "https://www.trailerbridge.com" },
    logo_crowley: { src: "/images/banner/logo_ally_crowley.png", alt: "Logo Crowley", href: "https://www.crowley.com" },
    logo_interport: { src: "/images/banner/logo_ally_interport.svg", alt: "Logo Interport", href: "https://interporthouston.com" },
    logo_cmacgm: { src: "/images/banner/logo_ally_cmacgm.svg", alt: "Logo CMACGM", href: "https://www.cmacgm-group.com" },
}

const logos_payments = {
    logo_visa: { src: "/images/banner/logo_payment_visa.svg", alt: "Logo Visa", href: "https://www.visa.com" },
    // logo_mastercard: { src: "/images/banner/logo_payment_mastercard.svg", alt: "Logo Mastercard", href: "https://www.mastercard.com" },
    logo_mastercard: { src: "/images/banner/logo_payment_mastercard.png", alt: "Logo Mastercard", href: "https://www.mastercard.com" },
    logo_americanexpress: { src: "/images/banner/logo_payment_americanexpress.svg", alt: "Logo Paypal", href: "https://www.americanexpress.com" },
}

export default function BannerLogos() {
    return (
        <div className="d-flex flex-column w-100 gap-3">
            <div className="d-flex justify-content-between w-100">
                <a href={logos.logo_nomanejes.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos.logo_nomanejes.src} width={"90px"} alt={logos.logo_nomanejes.alt} />
                </a>
                <a href={logos.logo_puerto_rico_car_transfer.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos.logo_puerto_rico_car_transfer.src} width={"140px"} alt={logos.logo_puerto_rico_car_transfer.alt} />
                </a>
                <a href={logos.logo_carro_a_centro_america.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos.logo_carro_a_centro_america.src} width={"85px"} alt={logos.logo_carro_a_centro_america.alt} />
                </a>
                <a href={logos.logo_pr_autotransport.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos.logo_pr_autotransport.src} width={"80px"} alt={logos.logo_pr_autotransport.alt} />
                </a>
                <a href={logos.logo_carmoversus.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos.logo_carmoversus.src} height={"40px"} alt={logos.logo_carmoversus.alt} />
                </a>
            </div>
            <div className="d-flex justify-content-between align-items-center w-100 ">
                <a href={logos.logo_shipshippersusa.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link w-50">
                    <img src={logos.logo_shipshippersusa.src} height={"40px"} alt={logos.logo_shipshippersusa.alt} className="w-100" />
                </a>
                <a href={logos.logo_ratesautotransport.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos.logo_ratesautotransport.src} height={"45px"} alt={logos.logo_ratesautotransport.alt} />
                </a>
                <a href={logos.logo_tucarroporusa.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos.logo_tucarroporusa.src} height={"28px"} alt={logos.logo_tucarroporusa.alt} />
                </a>
            </div>

            <div className="d-flex justify-content-between w-100">
                <a href={logos.logo_tcpamerica.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos.logo_tcpamerica.src} height={"40px"} alt={logos.logo_tcpamerica.alt} />
                </a>
            </div>

            <div className="d-flex justify-content-between w-100 gap-3">
                <a href={logos_ally.logo_ally_centraldispatch.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos_ally.logo_ally_centraldispatch.src} height={"35px"} alt={logos_ally.logo_ally_centraldispatch.alt} />
                </a>
                <a href={logos_ally.logo_ally_seaboard.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos_ally.logo_ally_seaboard.src} height={"35px"} alt={logos_ally.logo_ally_seaboard.alt} />
                </a>
                <a href={logos_ally.logo_ally_trailerbridge.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos_ally.logo_ally_trailerbridge.src} height={"35px"} alt={logos_ally.logo_ally_trailerbridge.alt} />
                </a>
            </div>

            <div className="d-flex justify-content-between align-items-center w-100">
                <a href={logos_ally.logo_crowley.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos_ally.logo_crowley.src} height={"40px"} alt={logos_ally.logo_crowley.alt} />
                </a>
                <a href={logos_ally.logo_interport.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos_ally.logo_interport.src} height={"70px"} alt={logos_ally.logo_interport.alt} />
                </a>
                <a href={logos_ally.logo_cmacgm.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos_ally.logo_cmacgm.src} height={"60px"} alt={logos_ally.logo_cmacgm.alt} />
                </a>
            </div>

            <div className="d-flex justify-content-between align-items-center gap-2 w-100">
                <div className="d-flex gap-2 justify-content-center align-items-center gap-2">

                    <a href={logos_payments.logo_visa.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                        <img src={logos_payments.logo_visa.src} height={"25px"} alt={logos_payments.logo_visa.alt} />
                    </a>
                    <a href={logos_payments.logo_mastercard.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                        <img src={logos_payments.logo_mastercard.src} height={"35px"} alt={logos_payments.logo_mastercard.alt} />
                    </a>
                    <a href={logos_payments.logo_americanexpress.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                        <img src={logos_payments.logo_americanexpress.src} height={"25px"} alt={logos_payments.logo_americanexpress.alt} />
                    </a>
                </div>
                <p className="text-center text-font" style={{ fontSize: "15px" }}>Comunícate con alguna de nuestras empresas HOY.</p>
            </div>

        </div>
    )
}